import { render, staticRenderFns } from "./ReceiptsDetails.vue?vue&type=template&id=6d12d370&scoped=true"
import script from "./ReceiptsDetails.vue?vue&type=script&lang=js"
export * from "./ReceiptsDetails.vue?vue&type=script&lang=js"
import style0 from "./ReceiptsDetails.vue?vue&type=style&index=0&id=6d12d370&prod&scoped=true&lang=css"
import style1 from "./ReceiptsDetails.vue?vue&type=style&index=1&id=6d12d370&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d12d370",
  null
  
)

export default component.exports